import CirclePercentage from '../CirclePercentage';

export default function Percentage(params) {
    const percentageCell = document.createElement('div');
    percentageCell.classList.add('w5-percentage-cell');

    if (!params.value && params.value !== 0) return percentageCell;

    const percentage = params.otherFields?.percentage
        ? params.data?.[params.otherFields.percentage]
        : params.value;
    if (percentage == null || !Number.isFinite(Number(percentage))) return percentageCell;
    const circle = CirclePercentage(percentage, {
        ...params,
        ...(params.otherFields?.percentage && { text: params.valueFormatted }),
    });

    percentageCell.appendChild(circle);
    return percentageCell;
}
